export interface Country {
  code: string
  name: string
  dial: string
  flag: string
  mask: string
}

// Mask format: # = digit placeholder. Everything else is literal.
// Generic fallback for countries without a known format: "### ### #### ##"

export const COUNTRIES: Country[] = [
  { code: 'AF', name: 'Afghanistan', dial: '+93', flag: '🇦🇫', mask: '## ### ####' },
  { code: 'AL', name: 'Albania', dial: '+355', flag: '🇦🇱', mask: '## ### ####' },
  { code: 'DZ', name: 'Algeria', dial: '+213', flag: '🇩🇿', mask: '### ## ## ##' },
  { code: 'AD', name: 'Andorra', dial: '+376', flag: '🇦🇩', mask: '### ###' },
  { code: 'AO', name: 'Angola', dial: '+244', flag: '🇦🇴', mask: '### ### ###' },
  { code: 'AG', name: 'Antigua and Barbuda', dial: '+1268', flag: '🇦🇬', mask: '### ####' },
  { code: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷', mask: '## ####-####' },
  { code: 'AM', name: 'Armenia', dial: '+374', flag: '🇦🇲', mask: '## ### ###' },
  { code: 'AU', name: 'Australia', dial: '+61', flag: '🇦🇺', mask: '### ### ###' },
  { code: 'AT', name: 'Austria', dial: '+43', flag: '🇦🇹', mask: '### ######' },
  { code: 'AZ', name: 'Azerbaijan', dial: '+994', flag: '🇦🇿', mask: '## ### ## ##' },
  { code: 'BS', name: 'Bahamas', dial: '+1242', flag: '🇧🇸', mask: '### ####' },
  { code: 'BH', name: 'Bahrain', dial: '+973', flag: '🇧🇭', mask: '#### ####' },
  { code: 'BD', name: 'Bangladesh', dial: '+880', flag: '🇧🇩', mask: '#### ######' },
  { code: 'BB', name: 'Barbados', dial: '+1246', flag: '🇧🇧', mask: '### ####' },
  { code: 'BY', name: 'Belarus', dial: '+375', flag: '🇧🇾', mask: '## ###-##-##' },
  { code: 'BE', name: 'Belgium', dial: '+32', flag: '🇧🇪', mask: '### ## ## ##' },
  { code: 'BZ', name: 'Belize', dial: '+501', flag: '🇧🇿', mask: '###-####' },
  { code: 'BJ', name: 'Benin', dial: '+229', flag: '🇧🇯', mask: '## ## ####' },
  { code: 'BT', name: 'Bhutan', dial: '+975', flag: '🇧🇹', mask: '## ### ###' },
  { code: 'BO', name: 'Bolivia', dial: '+591', flag: '🇧🇴', mask: '# #######' },
  { code: 'BA', name: 'Bosnia and Herzegovina', dial: '+387', flag: '🇧🇦', mask: '## ### ###' },
  { code: 'BW', name: 'Botswana', dial: '+267', flag: '🇧🇼', mask: '## ### ###' },
  { code: 'BR', name: 'Brazil', dial: '+55', flag: '🇧🇷', mask: '(##) #####-####' },
  { code: 'BN', name: 'Brunei', dial: '+673', flag: '🇧🇳', mask: '### ####' },
  { code: 'BG', name: 'Bulgaria', dial: '+359', flag: '🇧🇬', mask: '### ### ###' },
  { code: 'BF', name: 'Burkina Faso', dial: '+226', flag: '🇧🇫', mask: '## ## ## ##' },
  { code: 'BI', name: 'Burundi', dial: '+257', flag: '🇧🇮', mask: '## ## ## ##' },
  { code: 'CV', name: 'Cabo Verde', dial: '+238', flag: '🇨🇻', mask: '### ## ##' },
  { code: 'KH', name: 'Cambodia', dial: '+855', flag: '🇰🇭', mask: '## ### ###' },
  { code: 'CM', name: 'Cameroon', dial: '+237', flag: '🇨🇲', mask: '## ## ## ##' },
  { code: 'CA', name: 'Canada', dial: '+1', flag: '🇨🇦', mask: '(###) ###-####' },
  { code: 'CF', name: 'Central African Republic', dial: '+236', flag: '🇨🇫', mask: '## ## ## ##' },
  { code: 'TD', name: 'Chad', dial: '+235', flag: '🇹🇩', mask: '## ## ## ##' },
  { code: 'CL', name: 'Chile', dial: '+56', flag: '🇨🇱', mask: '# #### ####' },
  { code: 'CN', name: 'China', dial: '+86', flag: '🇨🇳', mask: '### #### ####' },
  { code: 'CO', name: 'Colombia', dial: '+57', flag: '🇨🇴', mask: '### ### ####' },
  { code: 'KM', name: 'Comoros', dial: '+269', flag: '🇰🇲', mask: '### ## ##' },
  { code: 'CG', name: 'Congo', dial: '+242', flag: '🇨🇬', mask: '## ### ####' },
  { code: 'CD', name: 'Congo (DRC)', dial: '+243', flag: '🇨🇩', mask: '## ### ####' },
  { code: 'CR', name: 'Costa Rica', dial: '+506', flag: '🇨🇷', mask: '#### ####' },
  { code: 'CI', name: "Cote d'Ivoire", dial: '+225', flag: '🇨🇮', mask: '## ## ## ##' },
  { code: 'HR', name: 'Croatia', dial: '+385', flag: '🇭🇷', mask: '## ### ####' },
  { code: 'CU', name: 'Cuba', dial: '+53', flag: '🇨🇺', mask: '# ### ####' },
  { code: 'CY', name: 'Cyprus', dial: '+357', flag: '🇨🇾', mask: '## ######' },
  { code: 'CZ', name: 'Czech Republic', dial: '+420', flag: '🇨🇿', mask: '### ### ###' },
  { code: 'DK', name: 'Denmark', dial: '+45', flag: '🇩🇰', mask: '## ## ## ##' },
  { code: 'DJ', name: 'Djibouti', dial: '+253', flag: '🇩🇯', mask: '## ## ## ##' },
  { code: 'DM', name: 'Dominica', dial: '+1767', flag: '🇩🇲', mask: '### ####' },
  { code: 'DO', name: 'Dominican Republic', dial: '+1809', flag: '🇩🇴', mask: '### ####' },
  { code: 'EC', name: 'Ecuador', dial: '+593', flag: '🇪🇨', mask: '## ### ####' },
  { code: 'EG', name: 'Egypt', dial: '+20', flag: '🇪🇬', mask: '### ### ####' },
  { code: 'SV', name: 'El Salvador', dial: '+503', flag: '🇸🇻', mask: '#### ####' },
  { code: 'GQ', name: 'Equatorial Guinea', dial: '+240', flag: '🇬🇶', mask: '### ### ###' },
  { code: 'ER', name: 'Eritrea', dial: '+291', flag: '🇪🇷', mask: '# ### ###' },
  { code: 'EE', name: 'Estonia', dial: '+372', flag: '🇪🇪', mask: '#### ####' },
  { code: 'SZ', name: 'Eswatini', dial: '+268', flag: '🇸🇿', mask: '## ## ####' },
  { code: 'ET', name: 'Ethiopia', dial: '+251', flag: '🇪🇹', mask: '## ### ####' },
  { code: 'FJ', name: 'Fiji', dial: '+679', flag: '🇫🇯', mask: '### ####' },
  { code: 'FI', name: 'Finland', dial: '+358', flag: '🇫🇮', mask: '## ### ## ##' },
  { code: 'FR', name: 'France', dial: '+33', flag: '🇫🇷', mask: '# ## ## ## ##' },
  { code: 'GA', name: 'Gabon', dial: '+241', flag: '🇬🇦', mask: '# ## ## ##' },
  { code: 'GM', name: 'Gambia', dial: '+220', flag: '🇬🇲', mask: '### ####' },
  { code: 'GE', name: 'Georgia', dial: '+995', flag: '🇬🇪', mask: '### ## ## ##' },
  { code: 'DE', name: 'Germany', dial: '+49', flag: '🇩🇪', mask: '### ########' },
  { code: 'GH', name: 'Ghana', dial: '+233', flag: '🇬🇭', mask: '## ### ####' },
  { code: 'GR', name: 'Greece', dial: '+30', flag: '🇬🇷', mask: '### ### ####' },
  { code: 'GD', name: 'Grenada', dial: '+1473', flag: '🇬🇩', mask: '### ####' },
  { code: 'GT', name: 'Guatemala', dial: '+502', flag: '🇬🇹', mask: '#### ####' },
  { code: 'GN', name: 'Guinea', dial: '+224', flag: '🇬🇳', mask: '## ### ###' },
  { code: 'GW', name: 'Guinea-Bissau', dial: '+245', flag: '🇬🇼', mask: '### ####' },
  { code: 'GY', name: 'Guyana', dial: '+592', flag: '🇬🇾', mask: '### ####' },
  { code: 'HT', name: 'Haiti', dial: '+509', flag: '🇭🇹', mask: '## ## ####' },
  { code: 'HN', name: 'Honduras', dial: '+504', flag: '🇭🇳', mask: '#### ####' },
  { code: 'HK', name: 'Hong Kong', dial: '+852', flag: '🇭🇰', mask: '#### ####' },
  { code: 'HU', name: 'Hungary', dial: '+36', flag: '🇭🇺', mask: '## ### ####' },
  { code: 'IS', name: 'Iceland', dial: '+354', flag: '🇮🇸', mask: '### ####' },
  { code: 'IN', name: 'India', dial: '+91', flag: '🇮🇳', mask: '##### #####' },
  { code: 'ID', name: 'Indonesia', dial: '+62', flag: '🇮🇩', mask: '###-###-####' },
  { code: 'IR', name: 'Iran', dial: '+98', flag: '🇮🇷', mask: '### ### ####' },
  { code: 'IQ', name: 'Iraq', dial: '+964', flag: '🇮🇶', mask: '### ### ####' },
  { code: 'IE', name: 'Ireland', dial: '+353', flag: '🇮🇪', mask: '## ### ####' },
  { code: 'IL', name: 'Israel', dial: '+972', flag: '🇮🇱', mask: '##-###-####' },
  { code: 'IT', name: 'Italy', dial: '+39', flag: '🇮🇹', mask: '### ### ####' },
  { code: 'JM', name: 'Jamaica', dial: '+1876', flag: '🇯🇲', mask: '### ####' },
  { code: 'JP', name: 'Japan', dial: '+81', flag: '🇯🇵', mask: '## #### ####' },
  { code: 'JO', name: 'Jordan', dial: '+962', flag: '🇯🇴', mask: '# #### ####' },
  { code: 'KZ', name: 'Kazakhstan', dial: '+7', flag: '🇰🇿', mask: '### ### ## ##' },
  { code: 'KE', name: 'Kenya', dial: '+254', flag: '🇰🇪', mask: '### ######' },
  { code: 'KI', name: 'Kiribati', dial: '+686', flag: '🇰🇮', mask: '## ###' },
  { code: 'KW', name: 'Kuwait', dial: '+965', flag: '🇰🇼', mask: '#### ####' },
  { code: 'KG', name: 'Kyrgyzstan', dial: '+996', flag: '🇰🇬', mask: '### ### ###' },
  { code: 'LA', name: 'Laos', dial: '+856', flag: '🇱🇦', mask: '## ## ### ###' },
  { code: 'LV', name: 'Latvia', dial: '+371', flag: '🇱🇻', mask: '## ### ###' },
  { code: 'LB', name: 'Lebanon', dial: '+961', flag: '🇱🇧', mask: '## ### ###' },
  { code: 'LS', name: 'Lesotho', dial: '+266', flag: '🇱🇸', mask: '#### ####' },
  { code: 'LR', name: 'Liberia', dial: '+231', flag: '🇱🇷', mask: '## ### ####' },
  { code: 'LY', name: 'Libya', dial: '+218', flag: '🇱🇾', mask: '## ### ####' },
  { code: 'LI', name: 'Liechtenstein', dial: '+423', flag: '🇱🇮', mask: '### ### ###' },
  { code: 'LT', name: 'Lithuania', dial: '+370', flag: '🇱🇹', mask: '### #####' },
  { code: 'LU', name: 'Luxembourg', dial: '+352', flag: '🇱🇺', mask: '### ### ###' },
  { code: 'MO', name: 'Macao', dial: '+853', flag: '🇲🇴', mask: '#### ####' },
  { code: 'MG', name: 'Madagascar', dial: '+261', flag: '🇲🇬', mask: '## ## ### ##' },
  { code: 'MW', name: 'Malawi', dial: '+265', flag: '🇲🇼', mask: '## ### ####' },
  { code: 'MY', name: 'Malaysia', dial: '+60', flag: '🇲🇾', mask: '##-### ####' },
  { code: 'MV', name: 'Maldives', dial: '+960', flag: '🇲🇻', mask: '### ####' },
  { code: 'ML', name: 'Mali', dial: '+223', flag: '🇲🇱', mask: '## ## ## ##' },
  { code: 'MT', name: 'Malta', dial: '+356', flag: '🇲🇹', mask: '#### ####' },
  { code: 'MH', name: 'Marshall Islands', dial: '+692', flag: '🇲🇭', mask: '### ####' },
  { code: 'MR', name: 'Mauritania', dial: '+222', flag: '🇲🇷', mask: '## ## ## ##' },
  { code: 'MU', name: 'Mauritius', dial: '+230', flag: '🇲🇺', mask: '#### ####' },
  { code: 'MX', name: 'Mexico', dial: '+52', flag: '🇲🇽', mask: '## #### ####' },
  { code: 'FM', name: 'Micronesia', dial: '+691', flag: '🇫🇲', mask: '### ####' },
  { code: 'MD', name: 'Moldova', dial: '+373', flag: '🇲🇩', mask: '## ### ###' },
  { code: 'MC', name: 'Monaco', dial: '+377', flag: '🇲🇨', mask: '## ## ## ##' },
  { code: 'MN', name: 'Mongolia', dial: '+976', flag: '🇲🇳', mask: '#### ####' },
  { code: 'ME', name: 'Montenegro', dial: '+382', flag: '🇲🇪', mask: '## ### ###' },
  { code: 'MA', name: 'Morocco', dial: '+212', flag: '🇲🇦', mask: '## #### ###' },
  { code: 'MZ', name: 'Mozambique', dial: '+258', flag: '🇲🇿', mask: '## ### ####' },
  { code: 'MM', name: 'Myanmar', dial: '+95', flag: '🇲🇲', mask: '## ### ####' },
  { code: 'NA', name: 'Namibia', dial: '+264', flag: '🇳🇦', mask: '## ### ####' },
  { code: 'NR', name: 'Nauru', dial: '+674', flag: '🇳🇷', mask: '### ####' },
  { code: 'NP', name: 'Nepal', dial: '+977', flag: '🇳🇵', mask: '## #### ####' },
  { code: 'NL', name: 'Netherlands', dial: '+31', flag: '🇳🇱', mask: '# ## ## ## ##' },
  { code: 'NZ', name: 'New Zealand', dial: '+64', flag: '🇳🇿', mask: '## ### ####' },
  { code: 'NI', name: 'Nicaragua', dial: '+505', flag: '🇳🇮', mask: '#### ####' },
  { code: 'NE', name: 'Niger', dial: '+227', flag: '🇳🇪', mask: '## ## ## ##' },
  { code: 'NG', name: 'Nigeria', dial: '+234', flag: '🇳🇬', mask: '### ### ####' },
  { code: 'KP', name: 'North Korea', dial: '+850', flag: '🇰🇵', mask: '### ### ####' },
  { code: 'MK', name: 'North Macedonia', dial: '+389', flag: '🇲🇰', mask: '## ### ###' },
  { code: 'NO', name: 'Norway', dial: '+47', flag: '🇳🇴', mask: '### ## ###' },
  { code: 'OM', name: 'Oman', dial: '+968', flag: '🇴🇲', mask: '#### ####' },
  { code: 'PK', name: 'Pakistan', dial: '+92', flag: '🇵🇰', mask: '### #######' },
  { code: 'PW', name: 'Palau', dial: '+680', flag: '🇵🇼', mask: '### ####' },
  { code: 'PS', name: 'Palestine', dial: '+970', flag: '🇵🇸', mask: '## ### ####' },
  { code: 'PA', name: 'Panama', dial: '+507', flag: '🇵🇦', mask: '####-####' },
  { code: 'PG', name: 'Papua New Guinea', dial: '+675', flag: '🇵🇬', mask: '### ####' },
  { code: 'PY', name: 'Paraguay', dial: '+595', flag: '🇵🇾', mask: '### ### ###' },
  { code: 'PE', name: 'Peru', dial: '+51', flag: '🇵🇪', mask: '### ### ###' },
  { code: 'PH', name: 'Philippines', dial: '+63', flag: '🇵🇭', mask: '### ### ####' },
  { code: 'PL', name: 'Poland', dial: '+48', flag: '🇵🇱', mask: '### ### ###' },
  { code: 'PT', name: 'Portugal', dial: '+351', flag: '🇵🇹', mask: '### ### ###' },
  { code: 'PR', name: 'Puerto Rico', dial: '+1787', flag: '🇵🇷', mask: '### ####' },
  { code: 'QA', name: 'Qatar', dial: '+974', flag: '🇶🇦', mask: '#### ####' },
  { code: 'RO', name: 'Romania', dial: '+40', flag: '🇷🇴', mask: '### ### ###' },
  { code: 'RU', name: 'Russia', dial: '+7', flag: '🇷🇺', mask: '### ###-##-##' },
  { code: 'RW', name: 'Rwanda', dial: '+250', flag: '🇷🇼', mask: '### ### ###' },
  { code: 'KN', name: 'Saint Kitts and Nevis', dial: '+1869', flag: '🇰🇳', mask: '### ####' },
  { code: 'LC', name: 'Saint Lucia', dial: '+1758', flag: '🇱🇨', mask: '### ####' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', dial: '+1784', flag: '🇻🇨', mask: '### ####' },
  { code: 'WS', name: 'Samoa', dial: '+685', flag: '🇼🇸', mask: '## ####' },
  { code: 'SM', name: 'San Marino', dial: '+378', flag: '🇸🇲', mask: '### ### ####' },
  { code: 'ST', name: 'Sao Tome and Principe', dial: '+239', flag: '🇸🇹', mask: '### ####' },
  { code: 'SA', name: 'Saudi Arabia', dial: '+966', flag: '🇸🇦', mask: '## ### ####' },
  { code: 'SN', name: 'Senegal', dial: '+221', flag: '🇸🇳', mask: '## ### ## ##' },
  { code: 'RS', name: 'Serbia', dial: '+381', flag: '🇷🇸', mask: '## ### ####' },
  { code: 'SC', name: 'Seychelles', dial: '+248', flag: '🇸🇨', mask: '# ### ###' },
  { code: 'SL', name: 'Sierra Leone', dial: '+232', flag: '🇸🇱', mask: '## ######' },
  { code: 'SG', name: 'Singapore', dial: '+65', flag: '🇸🇬', mask: '#### ####' },
  { code: 'SK', name: 'Slovakia', dial: '+421', flag: '🇸🇰', mask: '### ### ###' },
  { code: 'SI', name: 'Slovenia', dial: '+386', flag: '🇸🇮', mask: '## ### ###' },
  { code: 'SB', name: 'Solomon Islands', dial: '+677', flag: '🇸🇧', mask: '### ####' },
  { code: 'SO', name: 'Somalia', dial: '+252', flag: '🇸🇴', mask: '## ### ###' },
  { code: 'ZA', name: 'South Africa', dial: '+27', flag: '🇿🇦', mask: '## ### ####' },
  { code: 'KR', name: 'South Korea', dial: '+82', flag: '🇰🇷', mask: '##-####-####' },
  { code: 'SS', name: 'South Sudan', dial: '+211', flag: '🇸🇸', mask: '## ### ####' },
  { code: 'ES', name: 'Spain', dial: '+34', flag: '🇪🇸', mask: '### ### ###' },
  { code: 'LK', name: 'Sri Lanka', dial: '+94', flag: '🇱🇰', mask: '## ### ####' },
  { code: 'SD', name: 'Sudan', dial: '+249', flag: '🇸🇩', mask: '## ### ####' },
  { code: 'SR', name: 'Suriname', dial: '+597', flag: '🇸🇷', mask: '###-####' },
  { code: 'SE', name: 'Sweden', dial: '+46', flag: '🇸🇪', mask: '##-### ## ##' },
  { code: 'CH', name: 'Switzerland', dial: '+41', flag: '🇨🇭', mask: '## ### ## ##' },
  { code: 'SY', name: 'Syria', dial: '+963', flag: '🇸🇾', mask: '### ### ###' },
  { code: 'TW', name: 'Taiwan', dial: '+886', flag: '🇹🇼', mask: '### ### ###' },
  { code: 'TJ', name: 'Tajikistan', dial: '+992', flag: '🇹🇯', mask: '## ### ####' },
  { code: 'TZ', name: 'Tanzania', dial: '+255', flag: '🇹🇿', mask: '## ### ####' },
  { code: 'TH', name: 'Thailand', dial: '+66', flag: '🇹🇭', mask: '## ### ####' },
  { code: 'TL', name: 'Timor-Leste', dial: '+670', flag: '🇹🇱', mask: '### #### ###' },
  { code: 'TG', name: 'Togo', dial: '+228', flag: '🇹🇬', mask: '## ## ## ##' },
  { code: 'TO', name: 'Tonga', dial: '+676', flag: '🇹🇴', mask: '### ####' },
  { code: 'TT', name: 'Trinidad and Tobago', dial: '+1868', flag: '🇹🇹', mask: '### ####' },
  { code: 'TN', name: 'Tunisia', dial: '+216', flag: '🇹🇳', mask: '## ### ###' },
  { code: 'TR', name: 'Turkey', dial: '+90', flag: '🇹🇷', mask: '### ### ## ##' },
  { code: 'TM', name: 'Turkmenistan', dial: '+993', flag: '🇹🇲', mask: '## ######' },
  { code: 'TV', name: 'Tuvalu', dial: '+688', flag: '🇹🇻', mask: '## ####' },
  { code: 'UG', name: 'Uganda', dial: '+256', flag: '🇺🇬', mask: '### ######' },
  { code: 'UA', name: 'Ukraine', dial: '+380', flag: '🇺🇦', mask: '## ### ## ##' },
  { code: 'AE', name: 'United Arab Emirates', dial: '+971', flag: '🇦🇪', mask: '## ### ####' },
  { code: 'GB', name: 'United Kingdom', dial: '+44', flag: '🇬🇧', mask: '#### ######' },
  { code: 'US', name: 'United States', dial: '+1', flag: '🇺🇸', mask: '(###) ###-####' },
  { code: 'UY', name: 'Uruguay', dial: '+598', flag: '🇺🇾', mask: '## ### ###' },
  { code: 'UZ', name: 'Uzbekistan', dial: '+998', flag: '🇺🇿', mask: '## ### ## ##' },
  { code: 'VU', name: 'Vanuatu', dial: '+678', flag: '🇻🇺', mask: '### ####' },
  { code: 'VE', name: 'Venezuela', dial: '+58', flag: '🇻🇪', mask: '###-###-####' },
  { code: 'VN', name: 'Vietnam', dial: '+84', flag: '🇻🇳', mask: '## ### ## ##' },
  { code: 'YE', name: 'Yemen', dial: '+967', flag: '🇾🇪', mask: '### ### ###' },
  { code: 'ZM', name: 'Zambia', dial: '+260', flag: '🇿🇲', mask: '## ### ####' },
  { code: 'ZW', name: 'Zimbabwe', dial: '+263', flag: '🇿🇼', mask: '## ### ####' },
]

export function findCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((c) => c.code === code)
}

/**
 * Apply a mask to a digit string.
 * '#' in the mask is replaced by the next digit. Other chars are literal.
 * Returns the formatted string and the count of digits consumed.
 */
export function applyMask(digits: string, mask: string): string {
  let result = ''
  let digitIdx = 0

  for (let i = 0; i < mask.length && digitIdx < digits.length; i++) {
    if (mask[i] === '#') {
      result += digits[digitIdx]
      digitIdx++
    } else {
      result += mask[i]
      // If the next digit would go past, don't add trailing literals
      /* v8 ignore next -- loop guard already guaranteed by the loop condition */
      if (digitIdx >= digits.length) break
    }
  }

  // If there are more digits than the mask allows, append them raw
  if (digitIdx < digits.length) {
    result += digits.slice(digitIdx)
  }

  return result
}

/**
 * Count how many digit positions exist in the mask up to (and including)
 * a given cursor position in the formatted string.
 */
export function cursorToDigitIndex(formatted: string, cursorPos: number): number {
  let count = 0
  for (let i = 0; i < cursorPos && i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) count++
  }
  return count
}

/**
 * Given a digit index, find the cursor position in the formatted string
 * that sits just after that digit.
 */
export function digitIndexToCursor(formatted: string, digitIndex: number): number {
  let count = 0
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      count++
      if (count === digitIndex) return i + 1
    }
  }
  return formatted.length
}

/**
 * Parse an E.164 phone string into country + local number.
 * Tries longest dial code match first (e.g. +886 before +88).
 */
export function parseE164(value: string): { country: Country; localNumber: string } | null {
  if (!value.startsWith('+')) return null

  // Stable sort keeps the first country listed for a shared dial code (e.g. +1 → US)
  const byLongestDial = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length)

  for (const country of byLongestDial) {
    if (value.startsWith(country.dial)) {
      return { country, localNumber: value.slice(country.dial.length) }
    }
  }

  return null
}
